var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#222222",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,18.75Q16.211570000000002,18.75,16.86259,18.47465Q16.96439,18.43158,17.04945,18.360979999999998Q17.1345,18.29038,17.19557,18.19825Q17.25664,18.10611,17.28853,18.00027Q17.32042,17.89443,17.32042,17.78389Q17.32042,17.71002,17.30601,17.63757Q17.2916,17.56512,17.26333,17.49688Q17.23506,17.42863,17.194029999999998,17.36721Q17.15299,17.305790000000002,17.100749999999998,17.25356Q17.04852,17.20133,16.987099999999998,17.16029Q16.92568,17.11925,16.85744,17.090980000000002Q16.789189999999998,17.06271,16.71674,17.0483Q16.644289999999998,17.03389,16.57042,17.03389Q16.41834,17.03389,16.27826,17.09314L16.27816,17.09318L16.27709,17.09363Q15.90675,17.25,15.5,17.25Q14.67157,17.25,14.08579,16.66421Q13.5,16.07843,13.5,15.25Q13.5,14.42157,14.08579,13.83579Q14.67157,13.25,15.5,13.25Q16.32843,13.25,16.91421,13.83579Q17.5,14.42157,17.5,15.25Q17.5,15.32387,17.514409999999998,15.39632Q17.52882,15.46877,17.55709,15.53701Q17.58536,15.60526,17.6264,15.66668Q17.66744,15.7281,17.71967,15.78033Q17.7719,15.83256,17.83332,15.8736Q17.89474,15.91464,17.962989999999998,15.94291Q18.03123,15.97118,18.10368,15.98559Q18.17613,16,18.25,16Q18.32387,16,18.39632,15.98559Q18.46877,15.97118,18.537010000000002,15.94291Q18.60526,15.91464,18.66668,15.8736Q18.7281,15.83256,18.78033,15.78033Q18.83256,15.7281,18.8736,15.66668Q18.91464,15.60526,18.94291,15.53701Q18.97118,15.46877,18.985590000000002,15.39632Q19,15.32387,19,15.25Q19,13.80025,17.97487,12.775126Q16.94975,11.75,15.5,11.75Q14.05025,11.75,13.025126,12.775126Q12,13.80025,12,15.25Q12,16.69975,13.025126,17.72487Q14.05025,18.75,15.5,18.75Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 4,
    width: 5.5,
    height: 5.5,
    rx: 1.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#222222",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 4,
    width: 5.5,
    height: 5.5,
    rx: 1.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#222222",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 12.5,
    width: 5.5,
    height: 5.5,
    rx: 1.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#222222",
    fill: "none",
    strokeWidth: 1.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandOptions);
export default __webpack_public_path__ + "media/brand_options.a1210f2d.svg";
export { ForwardRef as ReactComponent };